/* global app */
import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { connect } from 'react-redux';
import { SBPayments } from 'sb-payments';
import CmsPage from 'CmsPage.js';

const { useSession, Withdraw } = SBPayments

const { WithdrawSection, SummaryProvider, Summary } = Withdraw

const AccountWithdraw = ({ isLogged, balance, currencyCode }) => {
  const session = useSession()

  // Watch for '2' which stands for MOBILE
  const [lang, setLang] = useState(() => `lang_${app.config.lang}_${app.config.mainCountryCode}_1_2`.toLowerCase())

  useEffect(() => {
    setLang(`lang_${app.config.lang}_${app.config.mainCountryCode}_1_2`.toLowerCase())
  }, [app.config, setLang])

  return (
    isLogged && (
      <SummaryProvider>
        <WithdrawSection lang={lang} session={session} balance={balance} currencyCode={currencyCode} />
        {createPortal(
          <Summary />,
          document.getElementById('spikeModalsWrapper')
        )}
        <CmsPage name="withdraw-footer-mobile" isPlaces={true} />
      </SummaryProvider>
    )
  )
}

const mapStateToProps = ({ Auth: { isLogged, user: { balance, currencyCode } } }) => {
  return {
    isLogged,
    balance,
    currencyCode
  }
}

export default connect(mapStateToProps)(AccountWithdraw)